import i18n from 'helpers/i18n';
import DetailPage from './DetailPage';
import { Route, Routes } from 'react-router-dom';
import useDocumentTitle from 'hooks/useDocumentTitle';
import PlaylistDetailPage from 'pages/LearningResources/Playlist/PlaylistDetailPage';
import PreferencesPage from 'pages/LearningResources/PreferencesPage';
import LearningResourcesProvider from './LearningResourcesContext';
import EducatorHeader from 'components/LearningResources/EducatorHeader';
import educatorHeaderMessages from 'components/LearningResources/EducatorHeader/messages';
import LearningResourcesHomePage from './LearningResourcesHomePage';

function LearningResources() {
  useDocumentTitle(i18n.ft(educatorHeaderMessages.title));

  return (
    <LearningResourcesProvider>
      <Routes>
        <Route element={<EducatorHeader />}>
          <Route path=":id" element={<DetailPage />} />
          <Route path="playlist/:id" element={<PlaylistDetailPage />} />
          <Route path="preferences" element={<PreferencesPage />} />
          <Route index element={<LearningResourcesHomePage />} />
        </Route>
      </Routes>
    </LearningResourcesProvider>
  );
}

export default LearningResources;
